import { MoreHoriz } from '@mui/icons-material'
import { Box, Button, IconButton, Link, Menu, MenuItem, Toolbar, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router'
import logo from '../../../../../../assets/Images/logos/logodark.svg'
import { getMenus } from '../../../../../../redux/actions/menus'
import { IRootState } from '../../../../../../redux/types'
import useScreenWidth from '../../../../hooks/useScreenWidth'
import HiddenMobile from '../../../../styles/HiddenMobile'
import { ClientMenu, LinkAppLogo, NavLogo, StyledAppBar, StyledToolbar } from '../../../../styles/layouts/MainLayout'
import ClientMobileMenu from '../../../ClientMobileMenu'
import BrandMobileFilter from '../../../filters/BrandMobileFilter'
import LanguageFilter from '../../../filters/LanguageFilter'
import GlobalSearch from '../../../inputs/GlobalSearch'
import AccountMenu from '../../AccountMenu'

function ClientAppBar() {
  const dispatch = useDispatch()
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const isLaptop = useScreenWidth(1120)

  const [menuItems, setMenuItems] = useState<any>([])
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userBrands } = useSelector((state: IRootState) => state.brand)
  const { menus } = useSelector((state: IRootState) => state.menu)
  const { globalLanguageId } = useSelector((state: IRootState) => state.global)
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    if (authUser?.me && menus.length > 0) {
      let tmpMenuItems: any = []
      authUser.menus.map((menu: any) => {
        return tmpMenuItems.push({
          id: menu.id,
          code: menu.code,
          path: `/${menu.path}`,
          list: []
        })
      })
      setMenuItems(tmpMenuItems)
    }
  }, [menus])

  useEffect(() => {
    if (authUser !== null && globalLanguageId !== null) dispatch(getMenus())
  }, [globalLanguageId, authUser])

  return (
    <>
      <StyledAppBar position="fixed" className="client">
        <Toolbar style={isMobile ? { maxHeight: 50, padding: 0 } : {}}>
          <LinkAppLogo underline={'none'} href="/inicio">
            <NavLogo src={String(logo)} alt={`Logo de ${import.meta.env.VITE_NAME}`} />
          </LinkAppLogo>

          {authUser?.me ? (
            <>
              {window.location.pathname !== '/terms' && (
                <HiddenMobile width={'100%'} display="flex" height={50}>
                  <Grid container style={{ margin: 0 }}>
                    {menuItems.map((item: any, index: number) => (
                      <ClientMenu
                        key={index}
                        style={isLaptop && index > 4 ? { display: 'none' } : {}}
                        className={window.location.pathname.split('/')[1] === item.path.split('/')[1] ? 'active' : ''}
                      >
                        <Link underline={'none'} data-testid={`menu-"${item.path.replace('/', '')}`} component={RouterLink} to={item.path}>
                          <Typography>{t(item?.code)}</Typography>
                        </Link>
                      </ClientMenu>
                    ))}
                  </Grid>
                  <IconButton sx={{ display: 'none' }} aria-controls="navbar-menu" aria-haspopup="true" onClick={handleClick}>
                    <MoreHoriz color="primary" />
                  </IconButton>
                  <Menu
                    id="navbar-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    onClick={handleClose}
                  >
                    {menuItems.slice(-3).map((item: any, index: number) => (
                      <MenuItem
                        sx={theme => ({
                          color: theme.palette.secondary.main,
                          '& p': {
                            fontWeight: 500
                          },
                          '&:hover': {
                            color: theme.palette.secondary.light
                          },
                          '&.active p': {
                            borderBottom: `3px solid ${theme.palette.secondary.main}`
                          }
                        })}
                        onClick={handleClose}
                        key={index}
                        data-testid={`menu-${item.path.replace('/', '')}`}
                        component={RouterLink}
                        className={window.location.pathname.split('/')[1] === item.path.split('/')[1] ? 'active' : ''}
                        to={item.path}
                      >
                        <Typography>{t(item?.code)}</Typography>
                      </MenuItem>
                    ))}
                  </Menu>
                </HiddenMobile>
              )}

              {userBrands.length > 0 && <BrandMobileFilter theme="client" type="nav" />}
              <Box display="flex" alignItems="center" justifyContent="space-between" width={isMobile ? '75%' : '50%'}>
                {!isMobile && <Box flexGrow={1} />}

                {window.location.pathname !== '/terms' && (
                  <HiddenMobile>
                    <GlobalSearch />
                  </HiddenMobile>
                )}

                <LanguageFilter theme="client" />

                {isMobile && <Box flexGrow={1} />}

                <AccountMenu theme="client" />
              </Box>
            </>
          ) : (
            <>
              <div style={{ flexGrow: 1 }} />
              <Box display="flex" alignItems="center" gap={8}>
                <Button href="/inicio" variant="text" color="primary">
                  Iniciar sesión
                </Button>

                <Button href="/registro" variant="contained" color="primary">
                  Registrarse
                </Button>
              </Box>
            </>
          )}
        </Toolbar>
      </StyledAppBar>

      <StyledToolbar />
      <ClientMobileMenu menus={menuItems} />
    </>
  )
}

export default ClientAppBar
